<template>
    <div class="solution-org-icon border border-grey-40 rounded flex items-center justify-center p-[1px]">
        <OrgIcon class="object-contain w-full h-full "  v-if="!orgInfoLogo || isLoadError" />
        <img class="w-full h-full object-contain" :src="orgInfoLogo" @error="handleLoadError" v-else />
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import OrgIcon from './OrgIcon.vue'

defineProps<{
    orgInfoLogo?: string;
}>();

const isLoadError = ref(false);

const handleLoadError = () => {
    isLoadError.value = true;
}
</script>
